import { ApiV2 } from '../../commonv2/api/ApiV2';
import { locatePath } from '../../common/RelativeUrl';
import { TrialLessonConfig } from '../../admin/types/trial';
import { UserInfo } from '../containers/common/userInfo/states/UserFormState';
import { TrialLessonId } from '../../commonv3/types/trialLessons';

export const TrialLessonConfigApis = {
  findGlobal(): Promise<TrialLessonConfig> {
    return new ApiV2(locatePath('/api/v2/trial_lesson_config')).get();
  },
};

export const TrialReservationApis = {
  reserveWithUserInput(lessonId: TrialLessonId, userInfo: Partial<UserInfo>) {
    return new ApiV2(locatePath('/api/v2'))
      .appendPath('/trial_lessons/:lessonId/event_reservation')
      .bind({ lessonId })
      .post({
        user: userInfo,
        payment_type: 'credit_card',
        validation_type: 'succinct_trial',
      });
  },
  reserve(lessonId: TrialLessonId) {
    return new ApiV2(locatePath('/api/v2'))
      .appendPath('/trial_lessons/:lessonId/event_reservation')
      .bind({ lessonId })
      .post({
        payment_type: 'credit_card',
        validation_type: 'succinct_trial',
      });
  },
};
